(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoito-cilt-testi"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Rutin grup sırası + ayarları (grup adları ürün bloğundaki "Grup" seçenekleriyle aynı olmalı)
     HOITO brief — 4 temel rutin adımı */
  var ORDER = ['Arındır ve Hazırla', 'Hedefe Yönelik Bakım', 'Haftalık Dopingleme', 'Onar ve Koru'];
  var CAPS = { 'Arındır ve Hazırla': 1, 'Hedefe Yönelik Bakım': 3, 'Haftalık Dopingleme': 2, 'Onar ve Koru': 2 };
  var ESSENTIAL = { 'Arındır ve Hazırla': true, 'Onar ve Koru': true };  // etiket eşleşmesi olmasa bile gösterilir
  var GROUP_NOTE = { 'Haftalık Dopingleme': 'Haftada 1–2', 'Onar ve Koru': 'Sabah & akşam' };
  var SET_GROUP = 'Set';

  var ICONS = {
    drop:'<path d="M12 3.5c3 3.4 5.5 6.3 5.5 9.3a5.5 5.5 0 11-11 0c0-3 2.5-5.9 5.5-9.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
    sun:'<circle cx="12" cy="12" r="4.2" stroke="currentColor" stroke-width="1.6"/><path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6L17 7M7 17l-1.4 1.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    spark:'<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
    target:'<circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="1.2" fill="currentColor"/>',
    shield:'<path d="M12 3l7 3v5c0 4.4-2.9 7.6-7 9-4.1-1.4-7-4.6-7-9V6l7-3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
    leaf:'<path d="M5 19c0-7 5-12 14-12 0 9-5 14-12 14-1.5 0-2-1-2-2z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 15c2-2 4-3 7-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    eye:'<path d="M3 12s3.5-6 9-6 9 6 9 6-3.5 6-9 6-9-6-9-6z" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="2.6" stroke="currentColor" stroke-width="1.6"/>',
    face:'<circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6"/><path d="M9 10h.01M15 10h.01M9 14.5c.9.8 1.9 1.2 3 1.2s2.1-.4 3-1.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>',
    grid:'<rect x="4" y="4" width="7" height="7" rx="1.4" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="4" width="7" height="7" rx="1.4" stroke="currentColor" stroke-width="1.6"/><rect x="4" y="13" width="7" height="7" rx="1.4" stroke="currentColor" stroke-width="1.6"/><rect x="13" y="13" width="7" height="7" rx="1.4" stroke="currentColor" stroke-width="1.6"/>',
    bolt:'<path d="M13 3L5 13h6l-1 8 8-10h-6l1-8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>',
    hair:'<path d="M5 20c0-7 3-13 7-13s7 6 7 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M8 20c0-5 1.5-9 4-9s4 4 4 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" opacity="0.55"/>',
    seed:'<path d="M12 21c-4 0-7-3-7-7 4 0 7 3 7 7zM12 21c4 0 7-3 7-7-4 0-7 3-7 7zM12 21V8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>',
    star:'<path d="M12 4l2.2 5 5.4.4-4.1 3.5 1.3 5.3L12 20.6 7.2 23.7l1.3-5.3L4.4 9.4 9.8 9 12 4z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/>',
    bottle:'<path d="M9.5 3h5M10 3v2.5c0 .6-.2 1-.6 1.5L8 8.6C7.4 9.3 7 10 7 11v7a3 3 0 003 3h4a3 3 0 003-3v-7c0-1-.4-1.7-1-2.4l-1.4-1.6c-.4-.5-.6-.9-.6-1.5V3" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>',
    check:'<path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    x:'<path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
  };
  function icon(name) { return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' + (ICONS[name] || ICONS.spark) + '</svg>'; }
  function tagList(str) { return String(str || '').toLowerCase().split(/[\s,]+/).filter(Boolean); }
  function fmtPrice(n) { n = Number(n) || 0; return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'; }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (m) { return ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' })[m]; }); }
  function firstTag(o) { return o ? (tagList(o.tags)[0] || '') : ''; }
  /* SEO: dinamik görsel alt etiketi → "HOITO <Ürün Adı> - Cilt Analiz Rutini" */
  function imgAlt(name) { return 'HOITO ' + String(name || '') + ' - Cilt Analiz Rutini'; }
  /* Fiyat bloğu — fiyat 0/boşsa hiç gösterme (ör. henüz katalogda olmayan ürün) */
  function priceHtml(p) { return Number(p.price) > 0 ? '<div class="htq-pcard__price"><b>' + fmtPrice(p.price) + '</b>' + (p.old ? '<s>' + fmtPrice(p.old) + '</s>' : '') + '</div>' : ''; }

  function initRoot(root) {
    if (!root || root.dataset.htqReady) return;
    root.dataset.htqReady = '1';

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-hoito-test-config]').textContent); } catch (e) { cfg = {}; }
    cfg.results = cfg.results || {}; cfg.analyzing = cfg.analyzing || {}; cfg.explore = cfg.explore || {};
    var QUESTIONS = (cfg.questions || []).filter(function (q) { return q && q.options && q.options.length; });
    var PRODUCTS = (cfg.products || []).filter(function (p) { return p && p.name; });
    PRODUCTS.forEach(function (p) { p._tags = tagList(p.tags); });

    var screens = {};
    root.querySelectorAll('[data-screen]').forEach(function (el) { screens[el.dataset.screen] = el; });
    var qEl = root.querySelector('[data-htq-question]');
    var fillEl = root.querySelector('[data-htq-fill]');
    var curEl = root.querySelector('[data-htq-cur]');
    var totEl = root.querySelector('[data-htq-total]');
    var backEl = root.querySelector('[data-htq-back]');
    var nextEl = root.querySelector('[data-htq-next]');
    var hintEl = root.querySelector('[data-htq-hint]');
    var resEl = root.querySelector('[data-htq-result]');
    var asideEl = root.querySelector('[data-htq-aside]');
    var toastEl = root.querySelector('[data-htq-toast]');
    var toastTx = root.querySelector('[data-htq-toast-text]');
    if (totEl) totEl.textContent = QUESTIONS.length;

    var state = { step: 0, answers: {} };
    var advanceTimer = null;

    function show(name) { Object.keys(screens).forEach(function (k) { screens[k].classList.toggle('is-active', k === name); }); }
    function scrollUp() { var top = root.getBoundingClientRect().top + window.pageYOffset - 90; if (window.pageYOffset > top || (top - window.pageYOffset) > 40) window.scrollTo({ top: top, behavior: 'smooth' }); }
    function optByVal(q, v) { for (var i = 0; i < q.options.length; i++) if (q.options[i].value === v) return q.options[i]; return null; }

    // Kullanıcının seçimleri — hem yan panelde (quiz) hem sonuç özetinde kullanılır
    function selectionsList() {
      return QUESTIONS.map(function (q, idx) {
        var a = state.answers[q.key];
        var answered = q.multi ? !!(a && a.length) : a != null;
        var text = '';
        if (answered) {
          text = (q.multi ? a : [a]).map(function (v) { var o = optByVal(q, v); return o ? o.label : ''; }).filter(Boolean).join(', ');
        }
        return { short: q.short || ('Soru ' + (idx + 1)), answered: answered, text: text, idx: idx };
      });
    }
    function renderAside() {
      if (!asideEl) return;
      var items = selectionsList();
      var rows = items.map(function (it) {
        var cls = 'htq-aside__row' + (it.answered ? ' is-done' : ' is-empty') + (it.idx === state.step ? ' is-current' : '');
        return '<li class="' + cls + '">' +
            '<span class="htq-aside__mark">' + (it.answered ? icon('check') : '') + '</span>' +
            '<span class="htq-aside__body"><span class="htq-aside__q">' + esc(it.short) + '</span>' +
            '<span class="htq-aside__a">' + (it.answered ? esc(it.text) : '—') + '</span></span>' +
          '</li>';
      }).join('');
      asideEl.innerHTML = '<span class="htq-aside__title">' + icon('list') + 'Seçimlerin</span><ul class="htq-aside__list">' + rows + '</ul>';
    }

    function renderQuestion() {
      clearTimeout(advanceTimer);
      var q = QUESTIONS[state.step];
      var sel = state.answers[q.key];
      var isMulti = !!q.multi;
      var html = '<h2 class="htq-display htq-q__title">' + esc(q.title) + '</h2>';
      if (q.help) html += '<p class="htq-q__help">' + esc(q.help) + '</p>';
      html += '<div class="htq-options"' + (Number(q.cols) === 2 ? ' data-cols="2"' : '') + ' role="' + (isMulti ? 'group' : 'radiogroup') + '">';
      q.options.forEach(function (o) {
        var on = isMulti ? (sel && sel.indexOf(o.value) > -1) : sel === o.value;
        html += '<button type="button" class="htq-opt' + (on ? ' is-selected' : '') + '" data-val="' + esc(o.value) + '" role="' + (isMulti ? 'checkbox' : 'radio') + '" aria-checked="' + (on ? 'true' : 'false') + '">' +
            '<span class="htq-opt__icon">' + icon(o.icon) + '</span>' +
            '<span class="htq-opt__body"><span class="htq-opt__label">' + esc(o.label) + '</span>' + (o.sub ? '<span class="htq-opt__sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
            '<span class="htq-opt__check">' + icon('check') + '</span>' +
          '</button>';
      });
      html += '</div>';
      qEl.innerHTML = html;

      fillEl.style.width = Math.max(Math.round(state.step / QUESTIONS.length * 100), 4) + '%';
      curEl.textContent = state.step + 1;
      backEl.hidden = state.step === 0;
      nextEl.firstChild.textContent = (state.step === QUESTIONS.length - 1 ? 'Analizi başlat' : 'Devam et') + ' ';
      hintEl.textContent = isMulti ? 'Birden fazla seçebilirsin' : '';
      updateNext();
      renderAside();

      qEl.querySelectorAll('.htq-opt').forEach(function (btn) {
        btn.addEventListener('click', function () { onPick(q, btn.getAttribute('data-val'), btn); });
      });
    }

    function onPick(q, val, btn) {
      if (q.multi) {
        var arr = state.answers[q.key] ? state.answers[q.key].slice() : [];
        var idx = arr.indexOf(val);
        if (idx > -1) arr.splice(idx, 1);
        else { if (q.max && arr.length >= q.max) { flashHint(q, 'En fazla ' + q.max + ' seçebilirsin'); return; } arr.push(val); }
        state.answers[q.key] = arr;
        btn.classList.toggle('is-selected');
        btn.setAttribute('aria-checked', btn.classList.contains('is-selected') ? 'true' : 'false');
        updateNext();
        renderAside();
      } else {
        state.answers[q.key] = val;
        qEl.querySelectorAll('.htq-opt').forEach(function (b) { var on = b === btn; b.classList.toggle('is-selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
        updateNext();
        renderAside();
        clearTimeout(advanceTimer);
        advanceTimer = setTimeout(goNext, 360);
      }
    }
    function flashHint(q, msg) { hintEl.textContent = msg; setTimeout(function () { hintEl.textContent = q.multi ? 'Birden fazla seçebilirsin' : ''; }, 1600); }
    function updateNext() { var q = QUESTIONS[state.step]; var sel = state.answers[q.key]; nextEl.disabled = q.multi ? !(sel && sel.length) : sel == null; }

    function goNext() {
      clearTimeout(advanceTimer);
      var q = QUESTIONS[state.step]; var sel = state.answers[q.key];
      if (q.multi ? !(sel && sel.length) : sel == null) return;
      if (state.step < QUESTIONS.length - 1) { state.step++; renderQuestion(); scrollUp(); }
      else runAnalyze();
    }
    function goBack() { clearTimeout(advanceTimer); if (state.step > 0) { state.step--; renderQuestion(); scrollUp(); } else show('intro'); }

    /* ===== Puanlama (etiket eşleşmesi) ===== */
    function compute() {
      var tags = {};
      var profile = [];
      QUESTIONS.forEach(function (q) {
        var a = state.answers[q.key]; if (a == null) return;
        var picks = q.multi ? a : [a];
        picks.forEach(function (val) {
          var o = optByVal(q, val); if (!o) return;
          tagList(o.tags).forEach(function (t) { tags[t] = (tags[t] || 0) + 1; });
          if (profile.length < 4) profile.push(o.label);
        });
      });

      PRODUCTS.forEach(function (p) {
        var sc = Number(p.priority) || 0, matched = 0;
        p._tags.forEach(function (t) { if (tags[t]) { sc += tags[t]; matched++; } });
        p._score = sc; p._matched = matched;
      });

      var byGroup = {};
      PRODUCTS.forEach(function (p) { (byGroup[p.group] = byGroup[p.group] || []).push(p); });
      Object.keys(byGroup).forEach(function (g) { byGroup[g].sort(function (a, b) { return b._score - a._score || b._matched - a._matched; }); });

      var routine = [];
      ORDER.forEach(function (g) {
        var list = byGroup[g]; if (!list || !list.length) return;
        var matched = list.filter(function (p) { return p._matched > 0; });
        var pick = matched.length ? matched : (ESSENTIAL[g] ? list.slice(0, 1) : []);
        pick.slice(0, CAPS[g] || 1).forEach(function (p) { routine.push({ group: g, product: p }); });
      });

      var setList = (byGroup[SET_GROUP] || []).filter(function (p) { return p._matched > 0; });
      var set = setList.length ? setList[0] : (byGroup[SET_GROUP] && byGroup[SET_GROUP][0]) || null;

      var answered = QUESTIONS.filter(function (q) { return state.answers[q.key] != null; }).length;
      // Eşleşme yüzdesi — yanıtlara göre değişir (deterministik, hep aynı çıkmaz)
      var seed = 0;
      QUESTIONS.forEach(function (q) {
        var a = state.answers[q.key]; if (a == null) return;
        (q.multi ? a : [a]).forEach(function (v) { for (var i = 0; i < String(v).length; i++) seed = (seed * 31 + String(v).charCodeAt(i)) % 1000003; });
      });
      var pct = 89 + (seed % 10);                 // 89–98 arası, seçimlere göre dağılır
      if (answered < QUESTIONS.length) pct -= 3;
      if (pct > 98) pct = 98; if (pct < 85) pct = 85;

      return { routine: routine, set: set, pct: pct, profile: profile };
    }

    /* ===== Analiz ekranı ===== */
    function runAnalyze() {
      show('analyze'); scrollUp();
      var result = compute();
      var titleEl = root.querySelector('[data-htq-analyze-title]');
      var lineEl = root.querySelector('[data-htq-analyze-line] span');
      var ring = root.querySelector('[data-htq-ring]');
      var ringPct = root.querySelector('[data-htq-ringpct]');
      if (titleEl) titleEl.textContent = cfg.analyzing.title || 'Cildin analiz ediliyor';
      var lines = (cfg.analyzing.lines && cfg.analyzing.lines.length) ? cfg.analyzing.lines : ['Cilt tipin değerlendiriliyor…', 'İhtiyaçların eşleştiriliyor…', 'Aktif içerikler seçiliyor…', 'Kişisel rutinin hazırlanıyor…'];
      var DUR = 2600, CIRC = 471, start = null, li = -1;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function frame(ts) {
        if (start == null) start = ts;
        var t = Math.min((ts - start) / DUR, 1), shown = Math.round(t * result.pct);
        if (ring) ring.style.strokeDashoffset = CIRC - (CIRC * shown / 100);
        if (ringPct) ringPct.textContent = shown + '%';
        var nl = Math.min(lines.length - 1, Math.floor(t * lines.length));
        if (nl !== li && lineEl) { li = nl; lineEl.textContent = lines[li]; }
        if (t < 1) requestAnimationFrame(frame); else setTimeout(function () { renderResult(result); }, 360);
      }
      if (reduce) { if (ring) ring.style.strokeDashoffset = CIRC - (CIRC * result.pct / 100); if (ringPct) ringPct.textContent = result.pct + '%'; if (lineEl) lineEl.textContent = lines[lines.length - 1]; setTimeout(function () { renderResult(result); }, 500); }
      else requestAnimationFrame(frame);
    }

    /* ===== Ürün kartı ===== */
    function pURL(p) { return p.url || ('/search?q=' + encodeURIComponent(p.name)); }
    function productCard(p) {
      var url = pURL(p);
      var media = p.image ? '<img class="htq-pcard__img" src="' + esc(p.image) + '" alt="' + esc(imgAlt(p.name)) + '" loading="lazy">' : '<span class="htq-pcard__ph">' + icon('bottle') + '</span>';
      var btn = p.variant
        ? '<button type="button" class="htq-pcard__btn" data-htq-add="' + esc(p.variant) + '">' + icon('check') + 'Sepete Ekle</button>'
        : '<a class="htq-pcard__btn" href="' + esc(url) + '">Ürünü İncele<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      return '<article class="htq-pcard">' +
          '<a class="htq-pcard__media" href="' + esc(url) + '">' + media + '</a>' +
          '<div class="htq-pcard__body">' +
            (p.group ? '<span class="htq-pcard__cat">' + esc(p.group) + '</span>' : '') +
            '<a class="htq-pcard__name" href="' + esc(url) + '">' + esc(p.name) + '</a>' +
            (p.active ? '<span class="htq-pcard__active">' + icon('drop') + esc(p.active) + '</span>' : '') +
            (p.reason ? '<span class="htq-pcard__reason">' + icon('spark') + esc(p.reason) + '</span>' : '') +
            priceHtml(p) +
            btn +
          '</div>' +
        '</article>';
    }
    // Rutin satırı — tam genişlik yatay kart (görsel sol · ad+içerik+neden orta · fiyat+buton sağ)
    function productRow(p) {
      var url = pURL(p);
      var media = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(imgAlt(p.name)) + '" loading="lazy">' : icon('bottle');
      var btn = p.variant
        ? '<button type="button" class="htq-pcard__btn" data-htq-add="' + esc(p.variant) + '">' + icon('check') + 'Sepete Ekle</button>'
        : '<a class="htq-pcard__btn" href="' + esc(url) + '">Ürünü İncele<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      return '<article class="htq-prow">' +
          '<a class="htq-prow__media" href="' + esc(url) + '" aria-label="' + esc(p.name) + '">' + media + '</a>' +
          '<div class="htq-prow__body">' +
            '<a class="htq-prow__name" href="' + esc(url) + '">' + esc(p.name) + '</a>' +
            '<div class="htq-prow__meta">' +
              (p.active ? '<span class="htq-pcard__active">' + icon('drop') + esc(p.active) + '</span>' : '') +
              (p.reason ? '<span class="htq-prow__reason">' + icon('spark') + esc(p.reason) + '</span>' : '') +
            '</div>' +
          '</div>' +
          '<div class="htq-prow__right">' +
            priceHtml(p) +
            btn +
          '</div>' +
        '</article>';
    }

    /* ===== Sonuç ===== */
    function renderResult(result) {
      var groups = {};
      result.routine.forEach(function (it) { (groups[it.group] = groups[it.group] || []).push(it.product); });

      var html = '<div class="htq-result">';
      html += '<div class="htq-result__head"><div>' +
          '<span class="htq-eyebrow"><span class="htq-dot"></span>' + icon('check') + esc(cfg.results.eyebrow || 'ANALİZ TAMAMLANDI') + '</span>' +
          '<h2 class="htq-display htq-result__heading">' + (cfg.results.heading || 'Cildine özel <em>rutinin</em> hazır') + '</h2>' +
          (cfg.results.lead ? '<p class="htq-result__lead">' + esc(cfg.results.lead) + '</p>' : '') +
        '</div>' +
        '<div class="htq-match"><div class="htq-match__ring" style="--p:' + result.pct + '"><div class="htq-match__inner"><b>' + result.pct + '%</b></div></div><span class="htq-match__cap">Cilt Uyumu</span></div>' +
      '</div>';

      // Seçim özeti — kullanıcı verdiği yanıtları görür, rutinin neden önerildiğini anlar
      var sels = selectionsList().filter(function (s) { return s.answered; });
      if (sels.length) {
        html += '<div class="htq-recap"><span class="htq-recap__title">' + icon('list') + esc(cfg.results.recap || 'Senin yanıtların') + '</span><div class="htq-recap__grid">' +
          sels.map(function (s) { return '<div class="htq-recap__item"><span class="htq-recap__q">' + esc(s.short) + '</span><span class="htq-recap__a">' + esc(s.text) + '</span></div>'; }).join('') +
          '</div></div>';
      }
      html += '<div class="htq-bridge"><span>' + icon('spark') + esc(cfg.results.bridge || 'Bu yanıtlara göre hazırlanan rutin') + '</span></div>';

      // Rutini adım adım, ALT ALTA diz; her adımın ürünleri tam genişlik yatay satır kartı
      var stepNo = 0;
      html += '<div class="htq-routine">';
      ORDER.forEach(function (g) {
        if (!groups[g] || !groups[g].length) return;
        stepNo++;
        html += '<div class="htq-rstep"><div class="htq-rstep__head">' +
            '<span class="htq-rstep__no">Adım ' + stepNo + '</span>' +
            '<h3 class="htq-rstep__title">' + esc(g) + '</h3>' +
            (GROUP_NOTE[g] ? '<span class="htq-rstep__note">' + esc(GROUP_NOTE[g]) + '</span>' : '') +
          '</div><div class="htq-rstep__items">' + groups[g].map(productRow).join('') + '</div></div>';
      });
      html += '</div>';

      if (result.set) {
        var sp = result.set, surl = pURL(sp);
        var sv = sp.image ? '<img src="' + esc(sp.image) + '" alt="' + esc(imgAlt(sp.name)) + '" loading="lazy">' : icon('bottle');
        var sbtn = sp.variant
          ? '<button type="button" class="htq-btn htq-btn--sm" data-htq-add="' + esc(sp.variant) + '">' + icon('check') + 'Seti Sepete Ekle</button>'
          : '<a class="htq-btn htq-btn--sm" href="' + esc(surl) + '">Seti İncele</a>';
        html += '<div class="htq-set"><div class="htq-set__visual">' + sv + '</div>' +
            '<div><span class="htq-set__eyebrow">Sana en uygun set</span><div class="htq-set__name">' + esc(sp.name) + '</div>' + (sp.reason ? '<p class="htq-set__sub">' + esc(sp.reason) + '</p>' : (sp.active ? '<p class="htq-set__sub">' + esc(sp.active) + '</p>' : '')) + '</div>' +
            '<div class="htq-set__right"><div class="htq-set__price"><b>' + fmtPrice(sp.price) + '</b>' + (sp.old ? '<s>' + fmtPrice(sp.old) + '</s>' : '') + '</div>' + sbtn + '</div></div>';
      }

      var routineVariants = result.routine.map(function (i) { return i.product.variant; }).filter(Boolean);
      var cartBtn = routineVariants.length
        ? '<button type="button" class="htq-btn" data-htq-addall>' + icon('check') + ' ' + esc(cfg.cartLabel || 'Tüm rutini sepete ekle') + '</button>'
        : '<a class="htq-btn" href="' + esc(cfg.explore.url || '/collections/all') + '">' + esc(cfg.explore.label || 'Önerilen ürünleri keşfet') + '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></a>';
      html += '<div class="htq-result__actions">' + cartBtn +
          '<button type="button" class="htq-restart" data-htq-restart><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12a8 8 0 108-8 8 8 0 00-6.3 3.1M4 4v4h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(cfg.restartLabel || 'Testi yeniden çöz') + '</button></div>';
      if (cfg.results.note) html += '<p class="htq-disclaimer">' + esc(cfg.results.note) + '</p>';
      html += '</div>';

      resEl.innerHTML = html;
      resEl.querySelectorAll('[data-htq-add]').forEach(function (b) { b.addEventListener('click', function () { addToCart([b.getAttribute('data-htq-add')], b); }); });
      var addAll = resEl.querySelector('[data-htq-addall]'); if (addAll) addAll.addEventListener('click', function () { addToCart(routineVariants, addAll); });
      var restart = resEl.querySelector('[data-htq-restart]'); if (restart) restart.addEventListener('click', function () { state = { step: 0, answers: {} }; clearURL(); show('intro'); scrollUp(); });
      show('result'); writeURL(); scrollUp();
    }

    function addToCart(variants, btn) {
      variants = (variants || []).filter(Boolean); if (!variants.length) return;
      var items = variants.map(function (id) { return { id: id, quantity: 1 }; });
      if (btn) btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { toast((cfg.addedText || 'Sepete eklendi') + (items.length > 1 ? ' (' + items.length + ' ürün)' : '')); document.dispatchEvent(new CustomEvent('cart:refresh')); })
        .catch(function () { toast('Şu an eklenemedi, ürün sayfasından deneyebilirsin.'); })
        .then(function () { if (btn) btn.disabled = false; });
    }
    var toastTimer = null;
    function toast(msg) { if (!toastEl) return; if (toastTx) toastTx.textContent = msg; toastEl.classList.add('is-show'); clearTimeout(toastTimer); toastTimer = setTimeout(function () { toastEl.classList.remove('is-show'); }, 2800); }

    /* ===== Paylaşılabilir URL (SEO) — sonuç linki ?cilt=..&sorun=.. ===== */
    // URL değeri = seçeneğin ilk etiketi (ör. cilt tipi → "yagli", sorun → "leke")
    function writeURL() {
      if (!window.history || !history.replaceState) return;
      var parts = [];
      QUESTIONS.forEach(function (q) {
        var a = state.answers[q.key]; if (a == null) return;
        var key = q.urlKey || q.key;
        var vals = (q.multi ? a : [a]).map(function (v) { return firstTag(optByVal(q, v)); }).filter(Boolean);
        if (vals.length) parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(vals.join('-')));
      });
      try { history.replaceState(history.state, '', location.pathname + (parts.length ? '?' + parts.join('&') : '') + location.hash); } catch (e) {}
    }
    function clearURL() {
      if (!window.history || !history.replaceState) return;
      try { history.replaceState(history.state, '', location.pathname + location.hash); } catch (e) {}
    }
    function optByTag(q, tag) {
      tag = String(tag || '').toLowerCase(); if (!tag) return null;
      for (var i = 0; i < q.options.length; i++) if (firstTag(q.options[i]) === tag) return q.options[i];
      for (var j = 0; j < q.options.length; j++) if (tagList(q.options[j].tags).indexOf(tag) > -1) return q.options[j];
      return null;
    }
    // Linkte tüm sorular doluysa doğrudan sonucu aç (paylaşım / geri-gel senaryosu)
    function applyURLState() {
      if (!QUESTIONS.length || !location.search) return false;
      var params = {};
      location.search.replace(/^\?/, '').split('&').forEach(function (kv) {
        if (!kv) return; var i = kv.indexOf('='); var k = decodeURIComponent(i < 0 ? kv : kv.slice(0, i)); params[k] = i < 0 ? '' : decodeURIComponent(kv.slice(i + 1));
      });
      var answers = {}, ok = true;
      QUESTIONS.forEach(function (q) {
        var raw = params[q.urlKey || q.key];
        if (raw == null || raw === '') { ok = false; return; }
        var picks = raw.split('-').map(function (t) { var o = optByTag(q, t); return o ? o.value : null; }).filter(Boolean);
        if (!picks.length) { ok = false; return; }
        answers[q.key] = q.multi ? picks : picks[0];
      });
      if (!ok) return false;
      state = { step: QUESTIONS.length - 1, answers: answers };
      renderResult(compute());
      return true;
    }

    root.querySelectorAll('[data-htq-start]').forEach(function (b) { b.addEventListener('click', function () {
      if (!QUESTIONS.length) { window.location.href = cfg.explore.url || '/collections/all'; return; }
      state = { step: 0, answers: {} }; renderQuestion(); show('quiz'); scrollUp();
    }); });
    if (nextEl) nextEl.addEventListener('click', goNext);
    if (backEl) backEl.addEventListener('click', goBack);

    // Paylaşılan link / sonuç URL'i ile gelindiyse doğrudan sonucu göster
    applyURLState();
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-hoito-test-root]').forEach(initRoot); }

  // Custom element: connectedCallback fires on the initial parse AND whenever the
  // element is (re)inserted — including this theme's client-side / morph navigation
  // (view-transitions), where DOMContentLoaded does NOT re-fire. Without this the
  // section never initializes when reached without a full page reload.
  if (window.customElements && !customElements.get('hoito-cilt-test')) {
    try {
      customElements.define('hoito-cilt-test', class extends HTMLElement {
        connectedCallback() { initRoot(this); }
      });
    } catch (e) {}
  }
  // Fallbacks: full page load + theme editor (initRoot is idempotent).
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoito-sertifikalar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function init(arc) {
    if (arc._hsArcReady) return; arc._hsArcReady = true;
    var stage = arc.querySelector('[data-hs-arc-stage]');
    var thumbs = Array.prototype.slice.call(arc.querySelectorAll('[data-hs-arc-thumb]'));
    var svg = arc.querySelector('[data-hs-arc-band]');
    var path = arc.querySelector('[data-hs-arc-path]');
    var img = arc.querySelector('[data-hs-arc-img]');
    var ph = arc.querySelector('[data-hs-arc-ph]');
    var capEl = arc.querySelector('[data-hs-arc-cap]');
    var descEl = arc.querySelector('[data-hs-arc-desc]');
    var preview = arc.querySelector('[data-hs-arc-preview]');
    var modal = arc.querySelector('[data-hs-arc-modal]');
    var mImg = modal && modal.querySelector('[data-hs-arc-modal-img]');
    var mCap = modal && modal.querySelector('[data-hs-arc-modal-cap]');
    if (!stage || !thumbs.length) return;
    var active = 0;

    function layout() {
      var W = stage.clientWidth; if (!W) return;
      if ((window.innerWidth || document.documentElement.clientWidth || W) <= 700) {
        for (var m = 0; m < thumbs.length; m++) { thumbs[m].style.left = ''; thumbs[m].style.top = ''; }
        stage.style.height = '';
        if (path) path.removeAttribute('d');
        return;
      }
      var ts = thumbs[0].offsetWidth || 96;
      var th = thumbs[0].offsetHeight || ts;
      var marginX = ts * 0.6 + 6;
      var usableW = Math.max(W - 2 * marginX, 10);
      var cx = W / 2;
      var droop = Math.min(W * 0.14, 96);
      var k = droop / Math.pow(Math.max(cx - marginX, 1), 2);
      var topPad = th / 2 + 8;
      var maxY = topPad;
      for (var i = 0; i < thumbs.length; i++) {
        var t = thumbs.length > 1 ? i / (thumbs.length - 1) : 0.5;
        var x = marginX + usableW * t;
        var y = topPad + k * Math.pow(x - cx, 2);
        thumbs[i].style.left = (x - ts / 2) + 'px';
        thumbs[i].style.top = (y - th / 2) + 'px';
        if (y > maxY) maxY = y;
      }
      var H = maxY + th / 2 + 16;
      stage.style.height = H + 'px';
      var xL = marginX, xR = marginX + usableW;
      var yEdge = topPad + k * Math.pow(xL - cx, 2);
      var Py = 2 * topPad - yEdge;
      if (svg) { svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svg.setAttribute('width', W); svg.setAttribute('height', H); }
      if (path) { path.setAttribute('d', 'M ' + xL + ' ' + yEdge + ' Q ' + cx + ' ' + Py + ' ' + xR + ' ' + yEdge); path.setAttribute('stroke-width', Math.max(th * 0.62, 42)); }
    }

    function setActive(i) {
      active = (i % thumbs.length + thumbs.length) % thumbs.length;
      for (var j = 0; j < thumbs.length; j++) {
        var on = j === active;
        thumbs[j].classList.toggle('is-active', on);
        thumbs[j].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var t = thumbs[active];
      var full = t.getAttribute('data-full') || '';
      var title = t.getAttribute('data-title') || '';
      var desc = t.getAttribute('data-desc') || '';
      if (img) {
        if (full) { img.src = full; img.alt = title; img.style.display = ''; if (ph) ph.style.display = 'none'; }
        else { img.removeAttribute('src'); img.style.display = 'none'; if (ph) ph.style.display = ''; }
      }
      if (capEl) capEl.textContent = title;
      if (descEl) descEl.textContent = desc;
      if (mCap) mCap.textContent = title;
      if (mImg && modal && !modal.hidden) {
        if (full) { mImg.src = full; mImg.alt = title; mImg.style.display = ''; }
        else { mImg.removeAttribute('src'); mImg.style.display = 'none'; }
      }
    }

    function openModal() {
      if (!modal) return;
      var t = thumbs[active], full = t.getAttribute('data-full') || '';
      if (mImg) {
        if (full) { mImg.src = full; mImg.style.display = ''; } else { mImg.removeAttribute('src'); mImg.style.display = 'none'; }
        mImg.alt = t.getAttribute('data-title') || '';
      }
      if (mCap) mCap.textContent = t.getAttribute('data-title') || '';
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var c = modal.querySelector('[data-hs-arc-close]'); if (c) c.focus();
    }
    function closeModal() { if (!modal) return; modal.hidden = true; document.documentElement.style.overflow = ''; }

    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { setActive(idx); }); });
    if (preview) {
      preview.addEventListener('click', openModal);
      preview.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openModal(); } });
    }
    if (modal) {
      var close = modal.querySelector('[data-hs-arc-close]'); if (close) close.addEventListener('click', closeModal);
      var prev = modal.querySelector('[data-hs-arc-prev]'); if (prev) prev.addEventListener('click', function () { setActive(active - 1); openModal(); });
      var next = modal.querySelector('[data-hs-arc-next]'); if (next) next.addEventListener('click', function () { setActive(active + 1); openModal(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') closeModal();
        else if (e.key === 'ArrowLeft') { setActive(active - 1); openModal(); }
        else if (e.key === 'ArrowRight') { setActive(active + 1); openModal(); }
      });
    }

    setActive(0);
    layout();
    if ('ResizeObserver' in window) { try { new ResizeObserver(layout).observe(stage); } catch (e) {} }
    else window.addEventListener('resize', layout);
    window.addEventListener('load', layout);
  }

  if (window.customElements && !customElements.get('hoito-cert-arc')) {
    try { customElements.define('hoito-cert-arc', class extends HTMLElement { connectedCallback() { init(this); } }); } catch (e) {}
  }
  function initAll(scope) { (scope || document).querySelectorAll('[data-hs-arc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
